import styled from '@emotion/styled';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MarkdownModalButton } from './HomologationCNC';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  .title {
    margin-bottom: 18px;
  }
`;

const CNCReportInstructions = () => {
  const { t } = useTranslation(['cnc-reports', 'common']);
  return (
    <Container>
      <Alert
        severity="info"
        sx={{
          mb: 2,
          whiteSpace: 'pre-line',
          backgroundColor: 'transparent',
          '& .MuiAlert-icon': {
            color: 'black',
          },
          color: 'black',
        }}
      >
        {t('cnc-reports:dashboard.instruction.text')}
      </Alert>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
        <MarkdownModalButton
          buttonText={t('cnc-reports:dashboard.instruction.buttonText')}
          modalTitle={t('cnc-reports:dashboard.instruction.title')}
          markdownContent={t(
            'cnc-reports:dashboard.instruction.markdownContent',
          )}
          buttonVariant="text"
        />
      </div>
    </Container>
  );
};

export default CNCReportInstructions;
